import {Injectable} from '@angular/core';
import {Autowired} from '@angular-ru/autowired';
import {WebUtilities} from '@app/core/utilities/web.utilities';
import {Observable, of} from 'rxjs';
import {IRecuperationListeDonneesRequete} from '@app/core/interfaces/actions/i-recuperation-liste-donnees-requete';
import {SgiRestService} from '@app/core/services/sgi/sgi-rest.service';
import {API_LISTE_DEMANDE_PRISE_EN_CHARGE, STATUT_EN_ATTENTE_DE_CLOTURE} from '@app/core/constantes';
import {DatePipe} from '@angular/common';
import {IUserConnect} from '@app/core/interfaces/user/i-user-connect';
import {SecurityStateService} from '@app/core/states/security/security.state.service';

@Injectable({providedIn: 'root'})
export class AdherentAutocompleteFormRestApiService extends SecurityStateService implements IRecuperationListeDonneesRequete {
  @Autowired() restService: SgiRestService;
  @Autowired() datePipe: DatePipe;

  storageUser: IUserConnect = this.getUser();

  postArgsMute = {successMute: true, errorMute: false, headers: null, params: null};

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    const { autocomplete } = args;

    if (autocomplete.inputSearch === '') {
      const body = {items: []};
      return of({body: body});
    }

    const sendData = {...data,
      itemToSearch: {
        estHospitalisation: true,
        idPrestataireMedical: JSON.parse(window.sessionStorage.getItem('currentUser')).personne.idPrestataireMedical,
        libelleTypeStatut: STATUT_EN_ATTENTE_DE_CLOTURE,
        matricule: autocomplete.inputSearch,

        InfoSearchestHospitalisation: { Consider: true },
        InfoSearchidPrestataireMedical: { Consider: true },
        InfoSearchlibelleTypeStatut: { Consider: true },
        InfoSearchmatricule: { Consider: true },
      },
      TakeAll: false,
    };
    // tslint:disable-next-line:max-line-length
    return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_LISTE_DEMANDE_PRISE_EN_CHARGE}`, sendData, {...this.postArgsMute});
  }

}
